// Event autofocus can be used to focus on the first visible input field
// This search can be restricted to `within` a specific element
// and or `after` a specific element.
// `within` has a default to `after`'s form.

import { isVisible, isBefore } from "./helpers"
export const Autofocus = {
  init() {
    window.addEventListener("phx:autofocus", (e) => {
      const after = e.detail.after && document.querySelector(e.detail.after)
      const within = e.detail.within
        ? document.querySelector(e.detail.within)
        : after.closest("form")
      Autofocus.autofocus(within, after)
    })
  },
  // autofocus on first visible empty input
  autofocus(within, after) {
    const emptyInputs = within.querySelectorAll(
      "input[value=''], input:not([value])",
    )

    for (const input of emptyInputs) {
      if (isBefore(input, after)) continue
      if (isVisible(input)) {
        input.focus()
        return
      }
    }
  },
}
Autofocus.init()
